import { getKey } from '../../assets/utils'
// 针对API-rosewallet跳结果详情页或者列表页
export default {
  async mounted () {
    const { redirect, orderId, loanPlatform, productCd } = this.$route.query
    if (getKey('channel') === 'API-rosewallet' && redirect) {
      const _url = decodeURIComponent(redirect)
      this.$router.replace({ path: _url, query: { orderId, loanPlatform, productCd } })
    }
    this.$bus.$emit('ready')
  },
 
  render () {
    return <div />
  }
}
